module.exports = __webpack_public_path__ + "static/img/4.2532637.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/sp/4.png
// module id = GKuv
// module chunks = 0